<template>
  <div id="app" :class="{ 'app--with-tabbar': showTabbar }">
    <template v-if="isConfigLoaded">
      <router-view v-slot="{ Component }">
        <component :is="Component" />
      </router-view>

      <Teleport to="body">
        <van-tabbar
          v-if="showTabbar"
          route
          fixed
          class="custom-tabbar"
          style="z-index: 99"
        >
          <van-tabbar-item
            v-for="(item, index) in menuList"
            :key="index"
            :to="isSupportMenuItem(item) ? undefined : item.path"
            :icon="item.icon"
            @click="onTabItemClick(item, $event)"
          >
            {{ item.name }}
          </van-tabbar-item>
        </van-tabbar>
      </Teleport>
    </template>
    <div v-else class="loading-container">
      <van-loading type="spinner" color="#1989fa" size="24px" vertical>
        加载中...
      </van-loading>
    </div>
  </div>
</template>

<script setup>
import { computed, provide, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { Toast } from "vant";
import { openSupportChat } from "@/utils/support";

const store = useStore();
const route = useRoute();
const router = useRouter();
const overlayOpenCount = ref(0);

const setAppOverlayOpen = (open) => {
  if (open) {
    overlayOpenCount.value += 1;
    return;
  }
  overlayOpenCount.value = Math.max(0, overlayOpenCount.value - 1);
};

provide("setAppOverlayOpen", setAppOverlayOpen);

const isConfigLoaded = computed(() => !!store.state.config.webViewConfig);

const menuList = computed(() => {
  const config = store.state.config.webViewConfig;
  return config?.page_menu_list || [];
});

const isSupportMenuItem = (item) => {
  const name = String(item?.name || "");
  const path = String(item?.path || "").toLowerCase();
  return (
    name.includes("客服") ||
    path.includes("service") ||
    path.includes("kefu") ||
    path.includes("support") ||
    path.includes("customer")
  );
};

const onTabItemClick = (item, event) => {
  if (!isSupportMenuItem(item)) return;
  event?.preventDefault?.();
  event?.stopPropagation?.();
  openSupportChat({
    onNeedLogin: (msg) => {
      Toast(msg);
      router.push("/login");
    },
  });
};

const shouldShowTabbar = computed(() => {
  const currentPath = route.path;

  const inMenuList = menuList.value.some(
    (item) => !isSupportMenuItem(item) && item.path === currentPath
  );
  const isSubPage = currentPath.split("/").length > 2;

  return inMenuList && !isSubPage;
});

const showTabbar = computed(
  () => shouldShowTabbar.value && overlayOpenCount.value === 0
);
</script>

<style>
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

#app.app--with-tabbar {
  padding-bottom: 58px;
}

.custom-tabbar .van-tabbar-item {
  color: #333;
}

.custom-tabbar .van-tabbar-item--active {
  color: #d81e06;
}

/* 覆盖 WebView 注入的 bottom 偏移，强制贴底 */
html body .van-tabbar.custom-tabbar {
  position: fixed !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  width: 100% !important;
  transform: none !important;
  margin: 0 !important;
  padding-bottom: env(safe-area-inset-bottom) !important;
  box-sizing: border-box !important;
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
</style>
